<template>
  <div v-if="siteDetails">
    <p class="signedin-modal-header">
      {{ $t('common.user') }}
      {{
        siteDetails && siteDetails.areaMode == "checked in"
          ? "Checked in"
          : "Signed in"
      }}
    </p>
    <p class="signedin-modal-body">
      {{ user_name }} has
      {{
        siteDetails.areaMode == "checked in" ? $t('signInOut.checkedInto') : $t('signInOut.signedIn')
      }}
      “{{ siteDetails.siteName }} - {{ siteDetails.areaName }}” {{$t('common.at')}}
      {{ formattedVisitDate }}.
    </p>

    <hr class="btn-divider" />

    <div class="d-flex justify-content-center">
      <button
        @click="onCheckedInConfirm(), $bvModal.hide('dashboardActionOne')"
        class="signedin-confirm-btn"
      >
        {{$t('common.okay')}}
      </button>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["user_name", "siteDetails"],
  data() {
    return {
      formattedVisitDate: null,
    };
  },
  beforeMount() {
    this.formattedVisitDate = moment.utc(this.siteDetails.checkInTime)
    this.formattedVisitDate = moment(this.formattedVisitDate).local().format("DD/MM/YYYY - hh:mm A");
  },
  methods: {
    onCheckedInConfirm() {
      this.$emit("refreshGrid");
    },
  },
};
</script>

<style lang="scss" scoped>
.signedin-modal-header {
  
  font-size: 17px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  margin-inline-start: 30px;
}
.signedin-modal-body {
   
  font-size: 20px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0em;
  text-align: center;
  color: #787878;
  margin-inline-start: 30px;
  margin-top: 20px;
  padding-inline-end: 45px;
  overflow: hidden;
}
.signedin-confirm-btn {
  height: 33px;
  width: 111px;
  border-radius: 20px;
  margin: 30px auto 0;
  color: #ffffff;
  background: #103f5e;
  
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  text-align: center;
}
.btn-divider {
  color: #707070;
  width: 340px;
  margin: 35px auto 0px auto;
}
</style>
